<template>
    <div class="mb-4">
      <label for="period-selector" class="block text-sm font-medium text-gray-700 mb-2">
        Seleccionar Periodo:
      </label>
      <div class="relative">
        <select 
          id="period-selector" 
          v-model="selectedPeriod" 
          @change="handlePeriodChange"
          :disabled="loading"
          class="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
          <option value="" disabled>Seleccione un periodo...</option>
          <option v-for="period in periods" :key="period.idPeriod" :value="period.idPeriod">
            {{ period.description }} ({{ period.idPeriod }})
          </option>
        </select>

        <div v-if="loading" class="absolute right-8 top-1/2 transform -translate-y-1/2">
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
        </div>
      </div>
      
      <div v-if="error" class="mt-2 text-sm text-red-600">
        {{ error }}
      </div>
    </div>
  </template>
  
  <script>
  import { getPeriods } from "@/services/api";
  
  export default {
    name: 'PeriodSelector',
    props: {
      studentId: {
        type: String,
        required: true
      },
      modelValue: {
        type: String,
        default: ''
      }
    },
    emits: ['update:modelValue', 'period-changed'],
    data() {
      return {
        periods: [],
        loading: false,
        error: null,
        selectedPeriod: this.modelValue
      };
    },
    watch: {
      modelValue(newValue) {
        this.selectedPeriod = newValue;
      },
      studentId: {
        handler(newStudentId) {
          if (newStudentId) {
            this.loadPeriods();
          }
        },
        immediate: true
      }
    },
    methods: {
      async loadPeriods() {
        if (!this.studentId) return;
        
        this.loading = true;
        this.error = null;
        
        try {
          const response = await getPeriods({ idstudent: this.studentId });
          this.periods = response.data || [];
          
          //Si hay períodos y no hay uno seleccionado, seleccionar el más reciente
          if (this.periods.length > 0 && !this.selectedPeriod) {
            this.selectedPeriod = this.periods[0].idPeriod;
            this.handlePeriodChange();
          }
        } catch (error) {
          console.error("Error al obtener los periodos:", error);
          this.error = "Error al cargar los periodos. Por favor, intente nuevamente.";
        } finally {
          this.loading = false;
        }
      },
      handlePeriodChange() {
        this.$emit('update:modelValue', this.selectedPeriod);
        this.$emit('period-changed', this.selectedPeriod);
      }
    }
  };
  </script>